import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import './storeRow.scss';
import classNames from 'classnames';
import { FilledStar } from 'tedooo-web-design-system/icons';
import { connect } from 'react-redux';
import { Button } from 'tedooo-web-design-system/ui';

import ShoppingBag from 'photos/emptyState/shopImageEmptyState.png';
import { ROUTES } from 'constant/routes';
import { IStore2, IStoreRow } from 'types';
import { Image, Span } from 'components/helpers';
import PremiumTag from 'components/premiumTag/PremiumTag';
import FollowButton from 'components/followButton/FollowButton';
import { getDefaultAvatar } from 'store/user/helper';
import { superAdminMarkAsCrystalShop } from 'store/searchResult/SearchResultActions';
import VisionSellerBadge from 'components/visionSellerBadge/VisionSellerBadge';

const StoreRow: FC<IStoreRow> = ({ shop, onFollow, superAdminMarkShop, isSuperAdmin }) => {
  const avatar = shop.avatar || getDefaultAvatar(shop.userId);

  const navigate = useNavigate();

  const onClick = () => {
    navigate(`/${ROUTES.SHOP}/${shop.id}`);
  };

  const onFollowClick = (e: any) => {
    e.stopPropagation();
    onFollow({ shopId: shop.id, isFollowing: shop.isFollowing || false, userId: shop.userId });
  };

  const onSuperAdminMarkShopClick = (e: any) => {
    e.stopPropagation();
    superAdminMarkShop({ shopId: shop.id });
  };

  const imagesToDisplay = [
    ...shop.images,
    ShoppingBag,
    ShoppingBag,
    ShoppingBag,
    ShoppingBag,
  ].slice(0, 4);

  const markButtonText = shop.isMarkedAsCrystalShop ? 'Marked' : 'Mark';

  return (
    <div className="shop-container" onClick={onClick}>
      {shop.isPremium && <PremiumTag size="medium" />}
      <div className="images-container">
        {imagesToDisplay.map((image, i) => (
          <Image
            withOverlay
            withLoader
            src={image}
            className={classNames('shop-image', { empty: !shop.images[i] })}
            key={i}
          />
        ))}
      </div>
      <div className="bottom-container">
        <Image src={avatar} className="avatar" />
        {shop.rating > 0 && (
          <div className="rating">
            <FilledStar />
            {shop.rating.toFixed(2)}
          </div>
        )}
        <div className="text-container">
          <div className="shop-header">
            <Span className="shop-name" text={shop.name} />
          </div>
          <div className="details-container">
            <div className="details">
              <Span className="shop-username" text={shop.username} />
              <div className="dot" />
              <Span className="shop-category" text={shop.category} />
            </div>
            {shop.isVisionSeller && <VisionSellerBadge size="medium" />}
          </div>
        </div>
        <FollowButton
          isFollowing={shop.isFollowing || false}
          onFollowToggle={onFollowClick}
          type="secondary"
          isFullWidth
        />
        {isSuperAdmin && (
          <Button
            type="primary"
            size="medium"
            borderRadius="small"
            text={markButtonText}
            onClick={onSuperAdminMarkShopClick}
            isFullWidth
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: IStore2) => {
  const { isSuperAdmin } = state.user;

  return { isSuperAdmin };
};

const mapDispatchToProps = {
  superAdminMarkShop: superAdminMarkAsCrystalShop,
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreRow);
